// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { z } from 'zod';

/**
 * CRM sync status used to filter list views when the organization is connected
 * to a drift-detection CRM. Values mirror the backend syncStatuses filter.
 */
export const crmSyncStatusSchema = z.enum([
  'in-sync',
  'out-of-sync',
  'not-linked',
]);

export type CrmSyncStatus = z.infer<typeof crmSyncStatusSchema>;

export const CRM_SYNC_STATUSES = crmSyncStatusSchema.options;

export const CRM_SYNC_STATUS_LABELS: Record<CrmSyncStatus, string> = {
  'in-sync': 'In sync',
  'out-of-sync': 'Out of sync',
  'not-linked': 'Not linked',
};
